import React, { Fragment } from 'react';
import { Container, PlaceholderParagraph, PlaceholderLine, PlaceholderHeader, Placeholder } from 'semantic-ui-react';
import * as css from './Loading.module.css';

const Loading = () => {
  return (
    <Fragment>
      <Container>
        <Placeholder className={css.placeholder}>
          <PlaceholderHeader>
            <PlaceholderLine className={css.line} />
            <PlaceholderLine className={css.line} />
          </PlaceholderHeader>
          <PlaceholderParagraph>
            <PlaceholderLine className={css.line} />
            <PlaceholderLine className={css.line} />
            <PlaceholderLine className={css.line} />
            <PlaceholderLine className={css.line} />
            <PlaceholderLine className={css.line} />
          </PlaceholderParagraph>
        </Placeholder>
      </Container>
    </Fragment>
  );
};

export default React.memo(Loading);
